import { render, staticRenderFns } from "./IconCloudDownloadSolid.vue?vue&type=template&id=80c07fda"
import script from "./IconCloudDownloadSolid.vue?vue&type=script&lang=js"
export * from "./IconCloudDownloadSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports